import React from "react";

const DownloadIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_299_5451)">
      <path
        d="M3 16C2.44687 16 2 15.5811 2 15.0625C2 14.5439 2.44687 14.125 3 14.125H13C13.5531 14.125 14 14.5439 14 15.0625C14 15.5811 13.5531 16 13 16H3ZM8.70625 11.9746C8.31563 12.3408 7.68125 12.3408 7.29062 11.9746L3.29063 8.22461C2.9 7.8584 2.9 7.26367 3.29063 6.89746C3.68125 6.53125 4.31563 6.53125 4.70625 6.89746L7 9.04785V1.9375C7 1.41895 7.44688 1 8 1C8.55312 1 9 1.41895 9 1.9375V9.04785L11.2937 6.89746C11.6844 6.53125 12.3188 6.53125 12.7094 6.89746C13.1 7.26367 13.1 7.8584 12.7094 8.22461L8.70938 11.9746H8.70625Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_299_5451">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DownloadIcon;
